import Cookies from 'js-cookie'
import VueRouter from 'vue-router'

import { Login } from './modules/sign/Login'
import { CRV } from './modules/crv'
import { Register } from './modules/sign/Register'
import { Recovery } from './modules/sign/Recovery'
import ForceLogin from './modules/sign/ForceLogin'
import ForceLoginFromPartner from './modules/sign/ForceLoginFromPartner'

import { Requests } from './modules/home/requests'
import { Monitoring } from './modules/home/monitoring'
import { Profile } from './modules/home/profile'
import { ProfilePassword } from './modules/home/profilePassword'
import { Tariff } from './modules/home/tariff'
import { TariffCalculate } from './modules/home/tariffCalculate'
import { TariffHistory } from './modules/home/tariffHistory'
import { TariffBuy } from './modules/home/tariffBuy'
import { Costs } from './modules/home/costs'
import { Pricing } from './modules/home/pricing'
import { Contacts } from './modules/home/contacts'
import { PackageRequest } from './modules/home/packageRequest'
import { Integration } from './modules/home/integration'
import { Webinars } from './modules/home/webinars'
import { Presentations } from './modules/home/presentations'
import { RequestProducts } from './modules/home/requestProducts'
import { RequestProfile } from './modules/home/requestProfile'
import { RenewalMonitoring } from './modules/home/renewalMonitoring'
import { RequestEgr } from './modules/home/requestEgr'
import { RequestBalance } from './modules/home/requestBalance'
import { ReportExample } from './modules/home/reportExample'
import { RefinanceAnalysis } from './modules/home/refinanceAnalysis'

import NotFound from './modules/404'
import Instraction from './modules/home/Instraction/Instraction.vue'

const routes = [
  {
    name: 'requests',
    path: '/requests',
    component: Requests,
    meta: {
      navigation: true,
      icon: 'assignment',
      title: 'Запросы'
    }
  },
  {
    name: 'monitoring',
    path: '/monitoring',
    component: Monitoring,
    meta: {
      navigation: false,
      icon: 'desktop_windows',
      title: 'Мониторинг'
    }
  },
  {
    name: 'tariff',
    path: '/tariff',
    component: Tariff,
    meta: {
      tabs: 'tariff',
      navigation: true,
      icon: 'equalizer',
      title: 'Тарифы'
    }
  },
  {
    name: 'tariffHistory',
    path: '/tariff/history',
    component: TariffHistory,
    meta: {
      tabs: 'tariff',
      title: 'Расход по тарифу'
    }
  },
  {
    name: 'pricing',
    path: '/pricing',
    component: Pricing,
    meta: {
      tabs: 'pricing',
      navigation: true,
      icon: 'account_balance_wallet',
      title: 'Финансы'
    }
  },
  {
    name: 'costs',
    path: '/pricing/costs',
    component: Costs,
    meta: {
      tabs: 'pricing',
      title: 'Расходы'
    }
  },
  {
    name: 'profile',
    path: '/profile',
    component: Profile,
    meta: {
      title: 'Профиль компании'
    }
  },
  {
    name: 'profileEdit',
    path: '/profile/:edit',
    component: Profile,
    meta: {
      breadCrumbs: '/profile',
      title: 'Профиль компании - редактирование'
    }
  },
  {
    name: 'changePassword',
    path: '/change-password',
    component: ProfilePassword,
    meta: {
      title: 'Смена пароля'
    }
  },
  {
    name: 'tariffBuy',
    path: '/tariff/buy/:tariff',
    component: TariffBuy,
    meta: {
      breadCrumbs: -1,
      title: 'Тарифный план'
    }
  },
  {
    name: 'requestProducts',
    path: '/',
    component: RequestProducts,
    meta: {
      title: 'Создание запроса'
    }
  },
  {
    name: 'requestProfile',
    path: '/requestProfile',
    component: RequestProfile,
    meta: {
      breadCrumbs: '/',
      title: 'Создание запроса'
    }
  },
  {
    name: 'requestEgrip',
    path: '/requestEgrip',
    component: RequestEgr,
    meta: {
      breadCrumbs: '/',
      title: 'Выписка из ЕГРИП'
    }
  },
  {
    name: 'requestEgrul',
    path: '/requestEgrul',
    component: RequestEgr,
    meta: {
      breadCrumbs: '/',
      title: 'Выписка из ЕГРЮЛ'
    }
  },
  {
    name: 'requestBalance',
    path: '/requestBalance',
    component: RequestBalance,
    meta: {
      breadCrumbs: '/',
      title: 'Балансы, бухгалтерские отчеты'
    }
  },
  {
    name: 'reportExample',
    path: '/reportExample/:id',
    component: ReportExample,
    meta: {
      title: 'Пример отчета'
    }
  },
  {
    name: 'forceLogin',
    path: '/sign/profile',
    component: ForceLogin,
    meta: {
      title: 'Авторизация',
      layout: 'sign'
    }
  },
  {
    name: 'forceLoginFromPartner',
    path: '/sign/fromPartner',
    component: ForceLoginFromPartner,
    meta: {
      title: 'Авторизация от партнера',
      layout: 'sign'
    }
  },
  {
    name: 'login',
    path: '/sign/login',
    component: Login,
    meta: {
      title: 'Авторизация',
      layout: 'sign'
    }
  },
  {
    name: 'crv',
    path: '/crv/:code',
    component: CRV,
    meta: {
      title: 'CRV',
      layout: 'sign'
    }
  },
  {
    name: 'register',
    path: '/sign/register',
    component: Register,
    meta: {
      title: 'Оставить заявку',
      layout: 'sign'
    }
  },
  {
    name: 'recovery',
    path: '/sign/recovery',
    component: Recovery,
    meta: {
      title: 'Восстановление пароля',
      layout: 'sign'
    }
  },
  {
    name: 'monitoringRenewal',
    path: '/monitoring/renewal',
    component: RenewalMonitoring,
    meta: {
      breadCrumbs: '/monitoring',
      title: 'Продление мониторинга'
    }
  },
  {
    name: 'refinanceAnalysis',
    path: '/refinance/analysis',
    component: RefinanceAnalysis,
    meta: {
      title: 'Анализ КИ'
    }
  },
  {
    name: '404',
    path: '*',
    component: NotFound,
    meta: {
      title: 'Страница не найдена'
    }
  }
]

const mode = 'history'

/**
 * <a :href="getUrl('report')" target="_blank">
 *
 * @param path
 * @returns {string}
 */
export function getUrl(path) {
  const trimmedPath = path.replace(/^\//, '')

  return `/${trimmedPath}`
}

export const router = new VueRouter({
  routes,
  mode
})

router.beforeEach((to, from, next) => {
  document.title = 'ЭБК System - ' + to.meta.title
  if (to.name === 'crv' && to.params.code) {
    next();
    return;
  }
  if (Cookies.get('token')) {
    switch (to.path) {
      case '/sign/demo':
      case '/sign/login':
      case '/sign/register':
      case '/sign/recovery':
      case '/sign/fromPartner':
        next('/')
        break
      case '/sign/profile':
        next()
        break
      default:
        next()
    }
  } else {
    switch (to.path) {
      case '/sign/demo':
      case '/sign/login':
      case '/sign/register':
      case '/sign/recovery':
      case '/sign/profile':
      case '/sign/fromPartner':
        next()
        break
      default:
        next('/sign/login')
    }
  }
})



// WEBPACK FOOTER //
// ./src/router.js